export default (list: string): string[] =>
  list
    .toLowerCase()
    .replace(/(, *)|( )/g, ",")
    .split(",")
    .filter((text) => /\S+@\S+\.\S+/.test(text));
